module.exports = __webpack_public_path__ + "static/media/twitter-circle-icon.75593c45.svg";